import cn from 'classnames';
import Paginator from '@creditflowresearch/uilib/Paginator';
import DataTable, { dataTableStyles } from '@creditflowresearch/uilib/Table/DataTable';
import Spinner from '@creditflowresearch/uilib/Loader/Spinner';
import { Tile } from '@creditflowresearch/uilib/Tile';
import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import TableWrapper from '@framework/ui/Molecules/Tables/TableWrapper';
import StatsTileContextProvider, {
  useStatsTileContext,
} from '@/creditflowresearch/application/ArticlesAndStats/Stats/StatsTile/StatsTileContext';
import { IStatsTileServerData } from '@/creditflowresearch/application/ArticlesAndStats/Stats/StatsTile/serverSide/getServerSideStatsTile';
import StatsTileHeader from './StatsTileHeader';
import columns from './columns';

import styles from './statsTile.module.scss';

const StatsTile = () => {
  const {
    statsData: {
      collection,
      totalCount,
      perPage,
      page,
      isFetching,
      paginate,
    },
  } = useStatsTileContext();

  return (
    <Tile dataTest="statsTile" className={ cn(styles.container, spacesStyles.mtl) }>
      <StatsTileHeader />
      { collection.length === 0 ? (
        <div className={ styles.emptyMessage }>
          { isFetching ? <Spinner /> : 'No matching records found' }
        </div>
      ) : (
        <div className={ styles.tableWrapper }>
          <TableWrapper className={ styles.tableWrapperOverride }>
            <DataTable
              dataTest="statsTileDataTable"
              columns={ columns }
              data={ collection }
              loadingComponent={ Spinner }
              isFetching={ isFetching }
              isHeaderVisible={ false }
              className={ dataTableStyles.isHoverable }
            />
          </TableWrapper>
          <Paginator
            dataTest="statsTilePaginator"
            page={ page }
            perPage={ perPage }
            totalCount={ totalCount }
            onPageChange={ ({ selected }) => paginate(selected) }
            isItemsPerPageVisible={ false }
          />
        </div>
      ) }
    </Tile>
  );
};

interface IStatsTileWithProviderProps {
  initialData: IStatsTileServerData,
}

const StatsTileWithProvider = ({ initialData }: IStatsTileWithProviderProps) => (
  <StatsTileContextProvider initialData={ initialData }>
    <StatsTile />
  </StatsTileContextProvider>
);

export default StatsTileWithProvider;
